import React, {useContext} from "react"
import {AssociatePerformanceContext} from "./context/AssociatePerformanceContext";
import Row from "@amzn/meridian/row";
import Heading from "@amzn/meridian/heading";
import Table, {TableCell, TableRow} from "@amzn/meridian/table"
import {AssociateFilterContext} from "./context/AssociateFilterContext";
import {FormattedMessage} from "react-intl";
import Link from "@amzn/meridian/link";
import {nullIfDefault} from "../util/Util";
import {YES} from "../util/Constants";
import Tooltip from "@amzn/meridian/tooltip";
import AssociatePerformanceMetrics from "./AssociatePerformanceMetrics";
import AssociateFilterWrapper from "./AssociateFilterWrapper";
import {CapabilityContext} from "../global/context/CapabilityContext";
import {useDeviceLayout} from "../common/context/DeviceLayoutContext";

const AssociatePerformanceView = (props) => {
    const {states} = useContext(AssociateFilterContext)
    const {viewModel, dispatch} = useContext(AssociatePerformanceContext);
    const {configViewModel} = useContext(CapabilityContext);
    const {spacingInset_shorthand3} = useDeviceLayout();
    const onSort = (sortDetails) => {
        dispatch({
            type: 'SORT_DATA',
            data: {column: sortDetails.sortColumn, direction: sortDetails.sortDirection}
        })
    }

    const sortedAssociatePerformance = [...viewModel.associatePerformance];
    sortedAssociatePerformance && sortedAssociatePerformance.sort((a, b) => {
        if (a[viewModel.sortPref.column] < b[viewModel.sortPref.column]) {
            return viewModel.sortPref.direction === "ascending" ? -1 : 1
        }
        if (a[viewModel.sortPref.column] > b[viewModel.sortPref.column]) {
            return viewModel.sortPref.direction === "ascending" ? 1 : -1
        }
        return 0
    })

    const onAssociateClick = (alias) => {
        props.history.push(`/pickassociates/${alias}`)
    }

    const onPicklistClicked = (associate) => {
        const currentPicklist = associate.currentPicklist ? associate.currentPicklist : {};
        const params = [
            "PickAssociates",
            nullIfDefault(currentPicklist.routeId),
            nullIfDefault(null),                                      /* status */
            nullIfDefault(null),                                      /* stagingLocation */
            nullIfDefault(null),                                      /* hazmatWeight */
            nullIfDefault(associate.alias),
            nullIfDefault(currentPicklist.routeCode),
            nullIfDefault(currentPicklist.stationCode),
            encodeURIComponent(nullIfDefault(currentPicklist.picklistId))
        ]
        const url = "/routeDetail/" + params.join("/");
        props.history.push(url)
    }

    return (
        <div>
            <Row widths={["grid-12"]} alignmentVertical="top" spacingInset={spacingInset_shorthand3}>
                <div>
                    <Heading level={2} type="h400" alignment="left">
                        <FormattedMessage id="associate.associates" defaultMessage="Pick Associates"/>
                    </Heading>
                    <AssociateFilterWrapper/>
                    <AssociatePerformanceMetrics {...props}/>
                    <div style={{ overflowX: "auto", width: "100%" }}>
                        <Table headerRows={1} spacing="small"
                               fixHeaderRows={true}
                               fixHeaderRowsFullWidth={true}
                               headerColumns={1}
                               stickyHeaderColumn={true}
                               sortColumn={viewModel.sortPref.column}
                               sortDirection={viewModel.sortPref.direction}
                               showStripes={true}
                               showDividers={true}
                               onSort={onSort}>
                            <TableRow>
                                <TableCell sortColumn="alias">
                                    <Tooltip position="top"
                                             title={"List of all associates who were assigned a picklist during the day."}>
                                        <FormattedMessage id="associate.associate" defaultMessage="Associate"/>
                                    </Tooltip>
                                </TableCell>
                                <TableCell sortColumn="active">
                                    <Tooltip position="top"
                                             title={"Yes, if associate is currently assigned to a picklist. No, otherwise."}>
                                        <FormattedMessage id="associate.currentAssignedPicklist"
                                                          defaultMessage="Picklist currently assigned"/>
                                    </Tooltip>
                                </TableCell>
                                <TableCell sortColumn="inActivePeriodInSeconds">
                                    <Tooltip position="top"
                                             title={"If currently not assigned any picklist, this is the time " +
                                             "since last picklist was completed. If currently assigned any picklist, " +
                                             "this is the time since last pick scan happened for this picklist."}>
                                        <FormattedMessage id="associate.lastActivityTime"
                                                          defaultMessage="Time since last activity"/>
                                    </Tooltip>
                                </TableCell>
                                <TableCell sortColumn="currentPicklistId">
                                    <Tooltip position="top"
                                             title={"This will be blank for associates not assigned any picklist."}>
                                        <FormattedMessage id="associate.picklistId" defaultMessage="Picklist ID"/>
                                    </Tooltip>
                                </TableCell>
                                <TableCell sortColumn="currentPicklistDurationInSeconds">
                                    <Tooltip position="top"
                                             title={"This will be blank for associates not assigned any picklist. " +
                                             "For active associates, this will be duration of current picklist."}>
                                        <FormattedMessage id="associate.currentPicklistDuration"
                                                          defaultMessage="Current picklist duration"/>
                                    </Tooltip>
                                </TableCell>
                                <TableCell sortColumn="totalIdleTimeInSeconds">
                                    <Tooltip position="top"
                                             title={"Sum of idle time between all picklists."}>
                                        <FormattedMessage id="associate.totalIdleTime"
                                                          defaultMessage="Total idle time between picklists"/>
                                    </Tooltip>
                                </TableCell>
                                { configViewModel.stationConfig.visibilityOfLastLocation && <TableCell sortColumn="lastLocation">
                                    <Tooltip position="top"
                                             title={"Last location of the cart by AA"}>
                                        <FormattedMessage id="associate.lastLocation"
                                                          defaultMessage="Last Location"/>
                                    </Tooltip>
                                </TableCell> }
                            </TableRow>
                            {sortedAssociatePerformance.map(associate => (
                                (states.length === 0 || states.includes(associate.active)) ? (
                                    <TableRow key={associate.alias}>
                                        <TableCell>
                                            <Link onClick={() => onAssociateClick(associate.alias)}>
                                                {associate.alias}
                                            </Link>
                                        </TableCell>
                                        <TableCell>{associate.active}</TableCell>
                                        <TableCell>{associate.inActivePeriod}</TableCell>
                                        <TableCell>
                                            {associate.active === YES ?
                                                <Link onClick={() => onPicklistClicked(associate)}>
                                                    {associate.currentPicklistCode}
                                                </Link> : "-"
                                            }
                                        </TableCell>
                                        <TableCell>{associate.currentPicklistDuration}</TableCell>
                                        <TableCell>{associate.totalIdleTime}</TableCell>
                                        { configViewModel.stationConfig.visibilityOfLastLocation &&
                                            <TableCell>{associate.lastLocation}</TableCell> }
                                    </TableRow>
                                ) : null
                            ))}
                        </Table>
                    </div>
                </div>
            </Row>
        </div>
    );
}

export default AssociatePerformanceView


// WEBPACK FOOTER //
// ./src/components/pickassociate/AssociatePerformanceView.js